import {CaseResult} from "src/app/model/lighthouse/ManagementModels";
import {CASE_TYPE_TO_CASE_SUB_TYPE_MAP} from "src/app/config/DropDownConfig";

/**
 * Mock case rows for dev (USE_MOCK_DATA=true). Shaped to the SearchCases contract:
 * summary columns only (View loads detail through LighthouseApi.getReview).
 * `availableActions` is computed per role by MockSearchApi (server-driven), so it is
 * left empty here. `auditorAlias` is mock-only, used to simulate server-side alias scoping.
 */
const H = 3600000;

const CASE_TYPES = ["Abuse", "AMCEagle", "ID_Fraud", "DPW_Compliance", "DUPLICATE_ACCOUNT"];
const COUNTRIES = ["US", "UK", "JP", "CA", "BR", "DE"];
const AUDIT_TYPES = ["PRIMARY_AUDIT", "SECONDARY_AUDIT", "REOPEN_AUDIT"];
const AUDITOR_ALIASES = ["jdoe", "asmith", "mchen", "nvinchnd"];

function generate(count: number): CaseResult[] {
    const rows: CaseResult[] = [];
    // Anchor to "now" so rows fall inside the default filter window (last 7 days). Spread the
    // 50 rows ~3h apart (~6 days total) so all rows show by default and date filtering still works.
    const base = Date.now();
    for (let i = 0; i < count; i++) {
        // Cycle status on 7 (coprime with the 6-country and 4-alias cycles) so every country
        // and auditor gets a mix of PENDING and COMPLETED rows. A multiple-of-3 cycle would
        // align with the country cycle and make e.g. every US row PENDING.
        const status = i % 7 < 3 ? "PENDING" : "COMPLETED";
        const decision = status === "COMPLETED" ? (i % 2 === 0 ? "NO_ACTION" : "OFFBOARDED") : null;
        const caseType = CASE_TYPES[i % CASE_TYPES.length];
        const subTypeOptions = CASE_TYPE_TO_CASE_SUB_TYPE_MAP[caseType] || [];
        const caseSubType = subTypeOptions.length ? subTypeOptions[i % subTypeOptions.length].value : "";
        rows.push({
            caseId: `case-${(i + 1).toString().padStart(4, "0")}-4d3e-9b02-${1000 + i}`,
            referenceId: `A${100000 + i * 7}FLEXDP`,
            referenceSubType: "DP",
            caseType: caseType,
            caseSubType: caseSubType,
            country: COUNTRIES[i % COUNTRIES.length],
            auditType: AUDIT_TYPES[i % AUDIT_TYPES.length],
            status,
            decision,
            creationDate: base - i * 3 * H,
            availableActions: [],   // computed per-role by MockSearchApi
            auditorAlias: AUDITOR_ALIASES[i % AUDITOR_ALIASES.length]
        });
    }
    return rows;
}

export const MOCK_CASE_LIST: CaseResult[] = generate(50);
